import React, { useEffect } from "react";
import { Form, Input, Select } from 'antd';
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { 
	getTrainingClassModuleDetails, 
	doTrainingClassModuleCreate, 
	doTrainingClassModuleUpdate,  
} from "../../../../../redux/trainingclass/trainingClassState";
import CrudButtons from "components/button/crudbuttons";
import { requiredField } from "utils/crudSagaHelper";
import { getLabel } from "utils";

const TrainingClassModuleForm = ({
	doCreate, 
	doUpdate, 
	onCancel, 
	recordData,
	classeId,
	getDetails,
	submitLabel,
	...props
 }) => {
		
  	const [form] = Form.useForm();
  	const { recordId, mode } = props;

	
	useEffect(() => {	
		if (recordData) {
			form.resetFields();
			const {class_module:classModule, ...rest } = recordData;

			if (rest.tcm_user_id === 0) {
      			delete rest.tcm_user_id;
			
			};
				form.setFieldsValue({
				...rest,
      			tcm_class_id: classeId,
				});
		}
	}, [recordData, classeId, form]);

	useEffect(() => {
		if (classeId && recordId === 0) {
			getDetails({ classeId, moduleId : 0 });
		}
	}, [classeId, recordId, getDetails]);
   
  	const onSubmit = (formData) => {
		try { 
			formData.tcm_class_id=classeId;
		if (!formData.tcm_user_id || formData.tcm_user_id === 0) {
      		delete formData.tcm_user_id;}

			recordData?.tcm_id > 0 ? doUpdate(formData): doCreate(formData);
		} catch (error) {
			console.error('Save failed:', error);
		}
	};

  
  	return (
		<Form 	layout="vertical"
				form={form}
				onFinish={onSubmit}
				className={mode !== "view" ? "form" : ""}
		>

		<FormItem 
			name="tcm_id" 
			hidden
		>
			<Input type="hidden" />
		</FormItem>

		<div className="col-span-3" >
			<FormItem
					name="tcm_module_id"
					label="Select Training Modules"
					rules={[requiredField]}
					>
					{mode !== "view" ? 
						<Select id="tcm_module_id"
						mode="multiple"
						classname="input-field"
						placeholder="Select training modules"
						allowClear
						showSearch
						optionFilterProp="label"
						options={recordData?.trainingModuleList}

						maxTagCount="responsive"
						style={{ width: "100%" }}
						/>
						:
						<label className="text-base label-value dark:text-white">
							{getLabel(recordData?.trainingModuleList, recordData?.tcm_module_id)}
						</label>
					}
			</FormItem>
      	</div>

		{mode === "edit" && (
			<div className="w-full flex justify-end">
				<CrudButtons
					mode={mode}
					recordId={recordData?.tcm_id ?? 0}
					isModal={true}
					allowEdit={false}
					modalId={
					recordData?.tcm_id > 0
						? "edit_class_module"
						: "add_class_module"
					}
					cancelLabel="Cancel"
					doHideModal={onCancel}
					submitLabel={submitLabel}
				/>
			</div>
      	)}
    </Form> 	
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.trainingClass.trainingClassModuleDetails?.data,
});

const mapDispatchToProps = (dispatch) => ({
	getDetails: (data) => dispatch(getTrainingClassModuleDetails(data)),
  	doCreate: (data) => dispatch(doTrainingClassModuleCreate(data)),
  	doUpdate: (data) => dispatch(doTrainingClassModuleUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingClassModuleForm);
